import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Contacthero from "./sections/Contacthero";
import ContactSection from "./sections/ContactSection";
import Contactcta from "./sections/Contactcta";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Contacthero />
      <ContactSection />
      <Contactcta />
      <Footer />
    </div>;
}